<template>
  <div class="container">
    <div class="box">
      <a
        class="sidebar"
        href="https://pgbayarind.id/"
      >
        <div>
          <LogoImage
            width="140"
            height="55"
          />
        </div>
      </a>
      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

import LogoImage from '@/assets/logo/logo-alt.svg';

@Component({
  components: {
    LogoImage,
  },
})
export default class RegisterLayout extends Vue {
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background: url("~@/assets/auth-background.svg?external") no-repeat;
  background-size: 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  background: $white;
  border-radius: 9px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  margin: 1%;

  .sidebar {
    background: linear-gradient(45deg, #0056a4 -10%, #0668c2 20%, #0c7ce2 50%);
    width: 350px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    @media screen and (max-width: 768px) {
      display: none;
    }
    &::after {
      content: "";
      background: url("~@/assets/logo/logob.png");
      position: absolute;
      left: 10%;
      width: 90%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .content {
    padding: 20px 40px;
  }
}
@media screen and (max-width: 1440px) {
  .box {
    max-height: 700px;
    overflow-y: scroll;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    width: 100%;
    height: 100vh;
    background: url("~@/assets/auth-background.svg?external") bottom center
      no-repeat;
    background-size: contain;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
